import { BLOCKED_FILE_ICON_CSS, GENERIC_CLASSIC_FILE_ICON_CSS } from './constants';
import { getFileIconFromSprite } from './getIconForFile';

const spriteStyles = require('owa-sprite/dist/styles/fileType_sprite.css');

export interface WellKnownFileIcon {
    classicFileIcon: string;
    smallFileIcon: string;
    extraSmallFileIcon: string;
}

// icons available in filepicker
const accessFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-accdb_32x32'],
    smallFileIcon: getFileIconFromSprite('accdb').small,
    extraSmallFileIcon: getFileIconFromSprite('accdb').extraSmall,
};
const audioFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-audio_32x32'],
    smallFileIcon: getFileIconFromSprite('audio').small,
    extraSmallFileIcon: getFileIconFromSprite('audio').extraSmall,
};
const calendarFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-calendar_32x32'],
    smallFileIcon: getFileIconFromSprite('calendar').small,
    extraSmallFileIcon: getFileIconFromSprite('calendar').extraSmall,
};
const codeFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-code_32x32'],
    smallFileIcon: getFileIconFromSprite('code').small,
    extraSmallFileIcon: getFileIconFromSprite('code').extraSmall,
};
const csvFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-csv_32x32'],
    smallFileIcon: getFileIconFromSprite('csv').small,
    extraSmallFileIcon: getFileIconFromSprite('csv').extraSmall,
};
const excelFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-xlsx_32x32'],
    smallFileIcon: getFileIconFromSprite('xlsx').small,
    extraSmallFileIcon: getFileIconFromSprite('xlsx').extraSmall,
};
const excelTemplateFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-xltx_32x32'],
    smallFileIcon: getFileIconFromSprite('xltx').small,
    extraSmallFileIcon: getFileIconFromSprite('xltx').extraSmall,
};
const exeFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-exe_32x32'],
    smallFileIcon: getFileIconFromSprite('exe').small,
    extraSmallFileIcon: getFileIconFromSprite('exe').extraSmall,
};
const genericFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles[GENERIC_CLASSIC_FILE_ICON_CSS],
    smallFileIcon: getFileIconFromSprite('generic').small,
    extraSmallFileIcon: getFileIconFromSprite('generic').extraSmall,
};
const infopathFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-infopath_32x32'],
    smallFileIcon: getFileIconFromSprite('infopath').small,
    extraSmallFileIcon: getFileIconFromSprite('infopath').extraSmall,
};
const linkFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-link_32x32'],
    smallFileIcon: getFileIconFromSprite('link').small,
    extraSmallFileIcon: getFileIconFromSprite('link').extraSmall,
};
const msgFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-email_32x32'],
    smallFileIcon: getFileIconFromSprite('email').small,
    extraSmallFileIcon: getFileIconFromSprite('email').extraSmall,
};
const oneFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-one_32x32'],
    smallFileIcon: getFileIconFromSprite('one').small,
    extraSmallFileIcon: getFileIconFromSprite('one').extraSmall,
};
const onepkgFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-onetoc_32x32'],
    smallFileIcon: getFileIconFromSprite('onetoc').small,
    extraSmallFileIcon: getFileIconFromSprite('onetoc').extraSmall,
};
const pblshFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-pblsh_32x32'],
    smallFileIcon: getFileIconFromSprite('pblsh').small,
    extraSmallFileIcon: getFileIconFromSprite('pblsh').extraSmall,
};
const pdfFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-pdf_32x32'],
    smallFileIcon: getFileIconFromSprite('pdf').small,
    extraSmallFileIcon: getFileIconFromSprite('pdf').extraSmall,
};
const photoFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-photo_32x32'],
    smallFileIcon: getFileIconFromSprite('photo').small,
    extraSmallFileIcon: getFileIconFromSprite('photo').extraSmall,
};
const powerpointFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-pptx_32x32'],
    smallFileIcon: getFileIconFromSprite('pptx').small,
    extraSmallFileIcon: getFileIconFromSprite('pptx').extraSmall,
};
const powerpointTemplateFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-potx_32x32'],
    smallFileIcon: getFileIconFromSprite('potx').small,
    extraSmallFileIcon: getFileIconFromSprite('potx').extraSmall,
};
const powerpointSlideShowFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-ppsx_32x32'],
    smallFileIcon: getFileIconFromSprite('ppsx').small,
    extraSmallFileIcon: getFileIconFromSprite('ppsx').extraSmall,
};
const projectFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-project_32x32'],
    smallFileIcon: getFileIconFromSprite('project').small,
    extraSmallFileIcon: getFileIconFromSprite('project').extraSmall,
};
const projectTemplateFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-mpt_32x32'],
    smallFileIcon: getFileIconFromSprite('mpt').small,
    extraSmallFileIcon: getFileIconFromSprite('mpt').extraSmall,
};
const rpmsgFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-rpmsg_32x32'],
    smallFileIcon: getFileIconFromSprite('rpmsg').small,
    extraSmallFileIcon: getFileIconFromSprite('rpmsg').extraSmall,
};
const txtFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-txt_32x32'],
    smallFileIcon: getFileIconFromSprite('txt').small,
    extraSmallFileIcon: getFileIconFromSprite('txt').extraSmall,
};
const vectorFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-vector_32x32'],
    smallFileIcon: getFileIconFromSprite('vector').small,
    extraSmallFileIcon: getFileIconFromSprite('vector').extraSmall,
};
const videoFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-video_32x32'],
    smallFileIcon: getFileIconFromSprite('video').small,
    extraSmallFileIcon: getFileIconFromSprite('video').extraSmall,
};
const visioDrawingFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-vsdx_32x32'],
    smallFileIcon: getFileIconFromSprite('vsdx').small,
    extraSmallFileIcon: getFileIconFromSprite('vsdx').extraSmall,
};
const visioStencilFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-vssx_32x32'],
    smallFileIcon: getFileIconFromSprite('vssx').small,
    extraSmallFileIcon: getFileIconFromSprite('vssx').extraSmall,
};
const visioTemplateFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-vstx_32x32'],
    smallFileIcon: getFileIconFromSprite('vstx').small,
    extraSmallFileIcon: getFileIconFromSprite('vstx').extraSmall,
};
const wordFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-docx_32x32'],
    smallFileIcon: getFileIconFromSprite('docx').small,
    extraSmallFileIcon: getFileIconFromSprite('docx').extraSmall,
};
const wordTemplateFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-dotx_32x32'],
    smallFileIcon: getFileIconFromSprite('dotx').small,
    extraSmallFileIcon: getFileIconFromSprite('dotx').extraSmall,
};
const zipFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles['fileType-icon-zip_32x32'],
    smallFileIcon: getFileIconFromSprite('zip').small,
    extraSmallFileIcon: getFileIconFromSprite('zip').extraSmall,
};

// icons not available in filepicker
const blockedFileIcon: WellKnownFileIcon = {
    classicFileIcon: spriteStyles[BLOCKED_FILE_ICON_CSS],
    smallFileIcon: getFileIconFromSprite('generic').small,
    extraSmallFileIcon: getFileIconFromSprite('generic').extraSmall,
};
const sharedFolderIcon: WellKnownFileIcon = {
    classicFileIcon: 'fileType-icon-sharedfolder_32x32',
    smallFileIcon: getFileIconFromSprite('sharedfolder').small,
    extraSmallFileIcon: getFileIconFromSprite('sharedfolder').extraSmall,
};

// !!! IMPORTANT !!!
// When updating which extensions map to which icons be sure to also update
// getCloudIconCSSForAttachment, as some icons need a different cloud for the background.
const wellKnownFileIconMap: { [key: string]: WellKnownFileIcon } = Object.freeze({
    '.3g2': videoFileIcon,
    '.3gp': videoFileIcon,
    '.aac': audioFileIcon,
    '.accdb': accessFileIcon,
    '.accdc': accessFileIcon,
    '.accde': accessFileIcon,
    '.accdr': accessFileIcon,
    '.accdt': accessFileIcon,
    '.acs': accessFileIcon,
    '.ai': vectorFileIcon,
    '.aiff': audioFileIcon,
    '.ape': audioFileIcon,
    '.asf': videoFileIcon,
    '.aspx': codeFileIcon,
    '.asx': videoFileIcon,
    '.avi': videoFileIcon,
    '.bmp': photoFileIcon,
    '.csv': csvFileIcon,
    '.dib': photoFileIcon,
    '.dgn': vectorFileIcon,
    '.doc': wordFileIcon,
    '.docm': wordFileIcon,
    '.docx': wordFileIcon,
    '.dot': wordTemplateFileIcon,
    '.dotm': wordFileIcon,
    '.dotx': wordTemplateFileIcon,
    '.email': msgFileIcon,
    '.emf': vectorFileIcon,
    '.eml': msgFileIcon,
    '.eps': vectorFileIcon,
    '.exe': exeFileIcon,
    '.flac': audioFileIcon,
    '.flv': videoFileIcon,
    '.gdraw': vectorFileIcon,
    '.gif': photoFileIcon,
    '.htm': codeFileIcon,
    '.html': codeFileIcon,
    '.ical': calendarFileIcon,
    '.icalendar': calendarFileIcon,
    '.ico': photoFileIcon,
    '.ics': calendarFileIcon,
    '.indd': vectorFileIcon,
    '.indt': vectorFileIcon,
    '.jfif': photoFileIcon,
    '.jpe': photoFileIcon,
    '.jpeg': photoFileIcon,
    '.jpg': photoFileIcon,
    '.log': txtFileIcon,
    '.lync': genericFileIcon,
    '.m1v': videoFileIcon,
    '.m4a': audioFileIcon,
    '.mdb': accessFileIcon,
    '.mht': codeFileIcon,
    '.mov': videoFileIcon,
    '.mp2': audioFileIcon,
    '.mp3': audioFileIcon,
    '.mp4': videoFileIcon,
    '.mpa': audioFileIcon,
    '.mpe': videoFileIcon,
    '.mpeg': videoFileIcon,
    '.mpg': videoFileIcon,
    '.mpp': projectFileIcon,
    '.mpt': projectTemplateFileIcon,
    '.mpv2': videoFileIcon,
    '.msg': msgFileIcon,
    '.odp': powerpointFileIcon,
    '.ods': excelFileIcon,
    '.odt': wordFileIcon,
    '.ogg': audioFileIcon,
    '.one': oneFileIcon,
    '.onepkg': onepkgFileIcon,
    '.onetoc2': onepkgFileIcon,
    '.oxps': vectorFileIcon,
    '.pd': vectorFileIcon,
    '.pdf': pdfFileIcon,
    '.plt': vectorFileIcon,
    '.png': photoFileIcon,
    '.pot': powerpointFileIcon,
    '.potm': powerpointFileIcon,
    '.potx': powerpointTemplateFileIcon,
    '.ppa': powerpointFileIcon,
    '.ppam': powerpointFileIcon,
    '.pps': powerpointFileIcon,
    '.ppsm': powerpointFileIcon,
    '.ppsx': powerpointSlideShowFileIcon,
    '.ppt': powerpointFileIcon,
    '.pptm': powerpointFileIcon,
    '.pptx': powerpointFileIcon,
    '.pro': vectorFileIcon,
    '.ps': vectorFileIcon,
    '.psd': photoFileIcon,
    '.pub': pblshFileIcon,
    '.rpmsg': rpmsgFileIcon,
    '.rtf': txtFileIcon,
    '.sketch': vectorFileIcon,
    '.srt': videoFileIcon,
    '.svg': vectorFileIcon,
    '.svgz': vectorFileIcon,
    '.swf': videoFileIcon,
    '.tif': photoFileIcon,
    '.tiff': photoFileIcon,
    '.txt': txtFileIcon,
    '.url': linkFileIcon,
    '.vcs': calendarFileIcon,
    '.vdx': visioDrawingFileIcon,
    '.vob': videoFileIcon,
    '.vsd': visioDrawingFileIcon,
    '.vsdx': visioDrawingFileIcon,
    '.vsl': visioDrawingFileIcon,
    '.vss': visioDrawingFileIcon,
    '.vssx': visioStencilFileIcon,
    '.vst': visioTemplateFileIcon,
    '.vstx': visioTemplateFileIcon,
    '.wav': audioFileIcon,
    '.wm': audioFileIcon,
    '.wma': audioFileIcon,
    '.wmd': videoFileIcon,
    '.wmf': vectorFileIcon,
    '.wms': videoFileIcon,
    '.wmv': videoFileIcon,
    '.wmz': videoFileIcon,
    '.wps': wordFileIcon,
    '.wri': wordFileIcon,
    '.xcl': excelFileIcon,
    '.xd': vectorFileIcon,
    '.xla': excelFileIcon,
    '.xlam': excelFileIcon,
    '.xls': excelFileIcon,
    '.xlsb': excelFileIcon,
    '.xlsm': excelFileIcon,
    '.xlsx': excelFileIcon,
    '.xlt': excelFileIcon,
    '.xltm': excelFileIcon,
    '.xltx': excelTemplateFileIcon,
    '.xml': codeFileIcon,
    '.xps': vectorFileIcon,
    '.xsn': infopathFileIcon,
    '.zip': zipFileIcon,
});
// Note: We are using the generic icons for classicFileIcon for google file types.
// This is okay because google file types can only be attached as reference attachments, which only use the small icon.
const wellKnownItemIconMimeTypeMap: {
    [key: string]: WellKnownFileIcon;
} = Object.freeze({
    'application/vnd.google-apps.document': {
        classicFileIcon: spriteStyles[GENERIC_CLASSIC_FILE_ICON_CSS],
        smallFileIcon: getFileIconFromSprite('gdoc').small,
        extraSmallFileIcon: getFileIconFromSprite('gdoc').extraSmall,
    },
    'application/vnd.google-apps.spreadsheet': {
        classicFileIcon: spriteStyles[GENERIC_CLASSIC_FILE_ICON_CSS],
        smallFileIcon: getFileIconFromSprite('gsheet').small,
        extraSmallFileIcon: getFileIconFromSprite('gsheet').extraSmall,
    },
    'application/vnd.google-apps.presentation': {
        classicFileIcon: spriteStyles[GENERIC_CLASSIC_FILE_ICON_CSS],
        smallFileIcon: getFileIconFromSprite('gslide').small,
        extraSmallFileIcon: getFileIconFromSprite('gslide').extraSmall,
    },
    'application/vnd.google-apps.form': {
        classicFileIcon: spriteStyles[GENERIC_CLASSIC_FILE_ICON_CSS],
        smallFileIcon: getFileIconFromSprite('gform').small,
        extraSmallFileIcon: getFileIconFromSprite('gform').extraSmall,
    },
    'application/onenote': oneFileIcon,
    'application/pdf': pdfFileIcon,
});

/**
 * Get icon CSS for attachment
 */
export default function getIconCSSForAttachment(
    extension: string,
    contentType: string,
    isBlocked: boolean,
    isFolder: boolean,
    embeddedItemClass: string
): WellKnownFileIcon {
    if (isBlocked) {
        return blockedFileIcon;
    }

    switch (embeddedItemClass) {
        case 'IPM.Note': // Email
        case 'IPM.Note.SMIME': // Smime Item Attachment
        case 'IPM.Note.SMIME.MultipartSigned': // Smime Clear Signed Item Attachment
            return msgFileIcon;
        case 'IPM.Schedule': // Calendar Item
        case 'IPM.Appointment': // Calendar Item
        case 'IPM.OLE.CLASS.{00061055-0000-0000-C000-000000000046}': // Meeting recurrence exception
            return calendarFileIcon;
        default:
            break;
    }

    // isFolder is undefined for reference attachments
    // VSO - 17242 Add attachmentsIsFolder property to the files folder for reference attachments
    if (!!isFolder) {
        return sharedFolderIcon;
    }

    const fileIcon: WellKnownFileIcon = wellKnownFileIconMap[extension && extension.toLowerCase()];

    // Some file types (OneNotes and Google files in particular) use mimetype instead of extension.
    // For OneNote Notebooks, we want to use more well known icon so that is checked first
    if (!fileIcon && contentType && contentType in wellKnownItemIconMimeTypeMap) {
        return wellKnownItemIconMimeTypeMap[contentType];
    }

    // Show generic file icons if we could not map the file to any type
    return fileIcon || genericFileIcon;
}
